import path from "path";

import { t } from "i18next";
import { isNotPresent } from "neetocist";

import { FILE_MIME_TYPES, ERROR_CODES } from "./constants";

export const getAcceptedFileTypes = allowedFileTypes => {
  const accepted = {};

  allowedFileTypes.split(", ").forEach(type => {
    const mimeTypes = FILE_MIME_TYPES[type] || ["application/octet-stream"];
    const extension = `.${type}`;

    if (isNotPresent(type) || isNotPresent(mimeTypes)) return;

    mimeTypes.forEach(mimeType => {
      if (accepted[mimeType]) accepted[mimeType].push(extension);
      else accepted[mimeType] = [extension];
    });
  });

  return accepted;
};

export const convertBytesToMb = bytes =>
  ((bytes - 10) / (1028 * 1024)).toFixed(2);

export const renderErrorMessage = (errorObject, maxFileSize, isMultiple) => {
  const error = errorObject.errors[0];
  const file = errorObject.file;
  if (error) {
    const { code } = error;
    if (code === ERROR_CODES.FILE_TOO_LARGE) {
      return t("neetoMolecules.fileUpload.filesDropzone.errors.fileTooLarge", {
        fileName: file.name,
        maxSize: `${Math.round(maxFileSize / 1048576)}MB`,
      });
    } else if (code === ERROR_CODES.FILE_INVALID_TYPE) {
      return t(
        "neetoMolecules.fileUpload.filesDropzone.errors.fileInvalidType",
        { fileType: path.extname(file.name) }
      );
    } else if (code === ERROR_CODES.TOO_MANY_FILES && !isMultiple) {
      return t("neetoMolecules.fileUpload.filesDropzone.errors.tooManyFiles", {
        maxFiles: 1,
      });
    }
  }

  return t("neetoMolecules.fileUpload.filesDropzone.errors.defaultError", {
    fileName: file.name,
  });
};

export const convertMbToBytes = mb => mb * 1028 * 1024 + 10;
